// console.log(`js/01-pageSections/carousel.js is working`);

const carouselCards = document.querySelector(`#carouselCards`);

const carouselItems = document.querySelectorAll(
  `.carousel.carousel-multi-item .carousel-item`
);

if (carouselCards) {
  const instructorCarousel = new bootstrap.Carousel(carouselCards, {
    interval: false,
    keyboard: false,
    ride: `carousel`,
    touch: true,
  });

  carouselCards.addEventListener(`slide.bs.carousel`, () => {
    carouselItems.forEach((item) => {
      item.children[0].classList.remove(`active`);
    });
  });

  carouselCards.addEventListener(`slid.bs.carousel`, () => {
    carouselItems.forEach((item) => {
      if (item.classList.contains(`active`)) {
        item.children[0].classList.add(`active`);
      }
    });
    setActiveInstructorCard(carouselItems);
  });

  /**
   * Move the carousel to the clicked on instructor.
   */
  const addCarouselItemEvent = (carouselItems) => {
    let carouselItemCard = document.querySelectorAll(`.carousel-item-card`);
    carouselItemCard.forEach((card) => {
      card.addEventListener(`click`, () => {
        instructorCarousel.to(card.dataset.carouselCardNumber - 1);
      });
    });
  };

  /**
   * Removes show class from carousel card expand content
   * button.
   */
  const removeInstructorCollapseShow = () => {
    let instructorContentContainer = document.querySelectorAll(
      `.carousel-content-container`
    );
    for (let container of instructorContentContainer) {
      if (container.classList.contains(`show`)) {
        container.classList.remove(`show`);
      } else {
        container.classList.add(`collapse`);
      }
    }
  };

  /**
   * Removes show class from carousel card expand content
   * button.
   */
  const addInstructorCollapseShow = () => {
    let carouselItemCard = document.querySelectorAll(`.carousel-item-card`);

    let instructorContentContainer = document.querySelectorAll(
      `.carousel-content-container`
    );

    for (let card of carouselItemCard) {
      if (card.classList.contains(`active`)) {
        for (let container of instructorContentContainer) {
          if (
            card.dataset.carouselCard == container.dataset.carouselCard &&
            container.classList.contains(`collapse`)
          ) {
            container.classList.remove(`collapse`);
          }
        }
      }
    }
  };

  /**
   * Loops through all the available carousel cards
   * and gets the data attr for the active card
   */
  const findActiveInstructor = (carouselItems) => {
    let active = ``;
    for (let item of carouselItems) {
      if (item.classList.contains(`active`)) {
        let children = item.children;

        for (let el of children) {
          if (el.classList.contains(`active`)) {
            let active = el.dataset.carouselCard;
            return active;
          }
        }
      }
    }
  };

  /**
   * Loops through the available carousel cards, compares
   * the active card from the carousel, then applies "active"
   * to the appropriate card.
   */
  const setActiveInstructorCard = (carouselItems) => {
    let cards = document.querySelectorAll(`.carousel-card`);

    let activeInstructor = findActiveInstructor(carouselItems);

    for (let card of cards) {
      if (card.id !== activeInstructor) {
        card.classList.remove(`active`);
        card.classList.add(`hidden`);
      } else {
        card.classList.remove(`hidden`);
        card.classList.add(`active`);
      }
    }
  };

  /**
   * Sets the initial active card class
   */
  const setFirstActiveInstructorCard = (carouselItems) => {
    carouselItems.forEach((item, i) => {
      if (i === 0) {
        item.children[0].classList.add(`active`);
      }
    });
  };

  /**
   * This function sets up the testimonial card track
   * to create a "x cards per row" layout
   */
  const createMultipleSlideTrack = (carouselItems, minPerSlide) => {
    carouselItems.forEach((el) => {
      // number of slides per carousel-item
      let nextCard = el.nextElementSibling;
      for (var i = 1; i < minPerSlide; i++) {
        if (!nextCard) {
          // wrap carousel by using first child
          nextCard = carouselItems[0];
        }
        let cloneChild = nextCard.cloneNode(true);
        el.appendChild(cloneChild.children[0]);
        nextCard = nextCard.nextElementSibling;
      }
    });
    setFirstActiveInstructorCard(carouselItems);
    setActiveInstructorCard(carouselItems);
  };

  /**
   * Create the amount of cards per row based on document size
   */
  const getWindowWidth = (documentWidth) => {
    if (documentWidth > 1200) {
      let minPerSlide = 3;
      createMultipleSlideTrack(carouselItems, minPerSlide);
      addCarouselItemEvent(carouselItems);
      addInstructorCollapseShow();
    } else if (documentWidth > 768) {
      let minPerSlide = 2;
      createMultipleSlideTrack(carouselItems, minPerSlide);
      addCarouselItemEvent(carouselItems);
      addInstructorCollapseShow();
    } else {
      let minPerSlide = 1;
      createMultipleSlideTrack(carouselItems, minPerSlide);
      removeInstructorCollapseShow();
    }
  };

  /**
   * Prevent resize event from calling too much based on resize
   */
  let timeout = false;
  let documentWidth = window.innerWidth;

  window.addEventListener(`load`, getWindowWidth(documentWidth));

  window.addEventListener(`resize`, () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      // Check window width has actually changed and it's not just iOS triggering a resize event on scroll
      if (window.innerWidth != documentWidth) {
        documentWidth = window.innerWidth;
        getWindowWidth(documentWidth);
      }
    }, 100);
  });
}
